import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { useContext } from "react";

const useHasDocuments = (product?: ProductModel): boolean => {
    const { documents } = product || useContext(ProductContext).product || {};

    return Boolean(documents?.length);
};

export default useHasDocuments;
